import { createModel } from '@/store/tools';

const model = {
    namespace: 'help_instruction',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getTableSource': T('getTableSource'),
        },
        actions: {
            'getTableSource': A('getTableSource'),
        },
        sagas: {
            'getTableSource': S('getTableSource', '/?cmd=com.xqxc.api.pig.mis.biz.platform.HelpCenterMisService.list'),

        },
        reducers: {
            'tableSource': R('getTableSource', []),
        }
    })
};
export default createModel(model);